module.exports = __webpack_public_path__ + "static/media/Public_relations_1_C.ebabaec2.png";